<template>
  <div class="left_block users profile">
    <UserInfo
      @photo="openPhotoModal"
      @open-modal="openCourseAddModal"
      @delete="deleteUser"
      @edit="openUserEditModal"
      :profile-info="userInfo"
    />

    <p class="actions_header" v-if="userRole != 'leader_admin'">
      <span class="left">Доступные курсы данного пользователя</span>
      <button class="right" @click="deleteChecked" :disabled="!rows.checked.length">
        <i class="mdi mdi-file-document-box-remove-outline"></i> Убрать курс из списка (отмеченные)
      </button>
    </p>

    <UsersInfoTable
      :is-loading="isLoading"
      v-if="userRole != 'leader_admin'"
      :rows="rows"
      :user-courses="userCourses"
      @delete="deleteCourse"
    />

    <b-modal @close="closeUserEditModal" :active.sync="userEditModal" has-modal-card scroll="keep">
      <EditUser :user-info="newUser" :modal-info="modal" @edit-user="editUser" @close-modal="closeUserEditModal" />
    </b-modal>

    <b-modal @close="closeCourseAddModal" :active.sync="courseAddModal" has-modal-card scroll="keep">
      <CourseAdd
        :modal-info="modal"
        @assign="assignChecked"
        :checked-courses="CheckedCourses"
        :categories-list="branchCategoriesList"
        @close-modal="closeCourseAddModal"
      />
    </b-modal>

    <b-modal @close="closePhotoModal" :active.sync="editPhoto" has-modal-card scroll="keep">
      <EditPhoto @save="changePhoto" @close-modal="closePhotoModal" />
    </b-modal>
  </div>
</template>

<script>
import EditPhoto from '@/components/user/profile/EditPhoto'
import UserInfo from '@/components/user/profile/UserInfo'
import UsersInfoTable from '@/components/leader/users/UsersInfoTable'
import EditUser from '@/components/leader/users/EditUser'
import CourseAdd from '@/components/admin/users/CourseAdd'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    UserInfo,
    UsersInfoTable,
    EditUser,
    CourseAdd,
    EditPhoto
  },
  data() {
    return {
      editPhoto: false,
      isLoading: true,
      userEditModal: false,
      modal: {
        header: 'Редактирование пользователя',
        button: 'Сохранить',
        creation: false,
        action: 'edit-user',
        date_start: new Date()
      },
      courseAddModal: false,
      newUser: this.defaultUser(),
      oldUser: this.defaultUser(),
      CheckedCourses: {
        ids: []
      },
      rows: {
        checked: []
      },
      branchCategoriesList: []
    }
  },
  computed: {
    profileInfo() {
      return this.$store.state.auth.currentUser
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    },
    modalCategoriesList() {
      return this.$store.state.categories.ModalCategoriesList
    },
    userInfo() {
      return this.$store.state.allUsers.UserInfo
    },
    userCourses() {
      return this.$store.state.allUsers.userCourses
    },
    userId() {
      return Number(this.$route.params.id)
    },
    userRole() {
      return this.$store.state.auth.role[0]
    }
  },
  mounted() {
    this.loadData()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      this.loadData()
    }
  },
  methods: {
    defaultUser() {
      return {
        name: '',
        surname: '',
        patronymic: '',
        position: '',
        email: '',
        password: '',
        id: ''
      }
    },
    loadData() {
      this.$axios2
        .get('users/' + this.userId)
        .then((resp) => {
          this.$store.commit('setUserInfo', { list: resp.data })
          if (this.userRole !== 'leader_admin') {
            let coursesList = []
            resp.data.user_course_data.forEach((user_course) => {
              const currentCourse = resp.data.courses.find((el) => el.id === user_course.course_id)
              const currentCategory = this.modalCategoriesList.find((el) => el.id === currentCourse.category_id)
              coursesList.push({
                date_start: user_course.date_start,
                name: currentCourse.name,
                id: currentCourse.id,
                days_limit: currentCourse.days_limit,
                status: user_course.status,
                category: {
                  name: currentCategory ? currentCategory.name : '-'
                }
              })
            })
            this.$store.commit('setUserCourses', { list: coursesList })
            this.isLoading = false
          }
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    },
    openCourseAddModal() {
      this.modal.date_start = new Date()
      this.$axios2
        .get('branches/' + this.userInfo.branch_id)
        .then((resp) => {
          this.$store.commit('setBranchInfo', { list: resp.data })
          let data = resp.data.courses.filter(
            (item) =>
              this.categoriesList.find((category) => item.category_id === category.id) &&
              !this.userCourses.some((course) => course.id === item.id)
          )
          if (!data.length) {
            this.$buefy.toast.open(toastDanger('Студенту назначены все курсы, доступные филиалу'))
            return
          }
          this.branchCategoriesList = new Array()
          let branchCategoriesList = new Array()
          this.categoriesList.forEach((category) => {
            branchCategoriesList.push({ name: category.name, id: category.id, courses: [] })
          })
          data.forEach((course) => {
            branchCategoriesList[branchCategoriesList.findIndex((el) => el.id === course.category_id)].courses.push(
              course
            )
          })
          this.branchCategoriesList = branchCategoriesList.filter((el) => el.courses.length)
          this.courseAddModal = true
        })
        .catch(this.$errorToast)
    },
    closeCourseAddModal() {
      this.courseAddModal = false
      this.CheckedCourses.ids = []
    },
    assignChecked() {
      this.$axios2
        .post('users/' + this.userId + '/courses/attach', {
          date_start: this.$moment(this.modal.date_start).format('YYYY-MM-DD'),
          course_ids: this.CheckedCourses.ids
        })
        .then(() => {
          this.closeCourseAddModal()
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteCourse(courseID) {
      this.$axios2
        .post('users/' + this.userId + '/courses/detach', {
          course_ids: typeof courseID === 'number' ? [courseID] : courseID
        })
        .then(() => {
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    deleteChecked() {
      let course_ids = []
      this.rows.checked.forEach((course) => {
        course_ids.push(course.id)
      })
      this.deleteCourse(course_ids)
      this.rows.checked = []
    },
    deleteUser() {
      this.$axios2
        .delete('users/' + this.userId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.$router.push('/users')
        })
        .catch(this.$errorToast)
    },
    editUser() {
      let request = {
        id: this.userId
      }
      Object.keys(this.newUser).forEach((key) => {
        if (this.newUser[key] != this.oldUser[key]) {
          request[key] = this.newUser[key]
        }
      })
      this.$axios2
        .post('users/' + this.userId, request)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.closeUserEditModal()
          this.loadData()
        })
        .catch(this.$errorToast)
    },
    openUserEditModal(info) {
      this.newUser = {
        name: info.name,
        surname: info.surname,
        patronymic: info.patronymic,
        position: info.position,
        email: info.email,
        password: info.password,
        id: info.id,
        branch_id: info.branch_id,
      }
      this.oldUser = {
        name: info.name,
        surname: info.surname,
        patronymic: info.patronymic,
        position: info.position,
        email: info.email,
        password: info.password,
        id: info.id,
        branch_id: info.branch_id,
      }
      this.userEditModal = true
    },
    closeUserEditModal() {
      this.userEditModal = false
    },
    changePhoto(file) {
      const fData = new FormData()
      fData.append('id', this.userId)
      fData.append('image', file)
      this.$axios2
        .post('users/' + this.userId, fData, { headers: { 'content-type': 'multipart/form-data' } })
        .then(() => {
          this.closePhotoModal()
          this.loadData()
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    closePhotoModal() {
      this.editPhoto = false
    },
    openPhotoModal() {
      this.editPhoto = true
    }
  }
}
</script>
